import React, { useState, useEffect, useMemo } from 'react';
import gsap from 'gsap';

import useScrollStore from '../../../common/store/useScrollStore';

const useTriggerAnimation = (ref: React.RefObject<HTMLElement>, vh: number, onComplete?: () => void) => {

  const [unsub, setUnsub] = useState(false);
  const ratio = useMemo(() => vh / 100, [vh]);

  useEffect(() => {
    if (!unsub) return useScrollStore.subscribe(state => {
      const trigger = (ratio * window.innerHeight) - (0.8 * window.innerHeight);

      if (-state.position > trigger) {
        gsap.to(ref.current, {
          duration: 1.5,
          ease: "power2.out",
          y: 0,
          opacity: 1,
          onComplete
        });

        setUnsub(true);
      }
    })
  }, [unsub, ratio]);
}

export default useTriggerAnimation;